import React from 'react';

import ActionSuccessModalContent from 'components/balances/actions/shared/ActionSuccessModalContent';

function UnlockSuccess() {
  return <ActionSuccessModalContent type="Unlock" chain="katanaChain" />;
}

export default UnlockSuccess;
